module.exports = function anonymous(data
/*``*/) {
var out='';return out;
}